export default "__VITE_ASSET__DjfEc6NB__"